import "./meetingTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import loading indicator
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const MeetingTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Meeting
  useEffect(() => {
    const fetchMeeting = async () => {
      setLoading(true); // Set loading state before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/meeting/findAllMeeting/${userId}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching meetings:", err);
      }
      setLoading(false); // Set loading state to false after fetching
    };
    fetchMeeting();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/meeting/deleteMeeting/${id}`
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting meeting:", err);
    }
  };

  const handleUpdate = (meetingData) => {
    navigate("/meeting/newMeeting", { state: { meeting: meetingData } }); // Pass user data to meeting
  };

  const meetingListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "title",
      headerName: "Meeting Title",
      width: 300,
    },
    {
      field: "description",
      headerName: "Meeting Description",
      width: 400,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 110,
    },
    {
      field: "editedDate",
      headerName: "Edited Date",
      width: 110,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <IconButton color="primary" aria-label="addButton">
            <Link to="/meeting/newMeeting">
              <Add />
            </Link>
          </IconButton>

          <IconButton
            onClick={() => handleUpdate(params.row)}
            color="primary"
            aria-label="update"
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => {
              setSelectedMeeting(params.row);
              setOpenDialog(true);
            }}
            color="error"
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedMeeting(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedMeeting) {
      await handleDelete(selectedMeeting._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Meetings
        </Typography>
        <Link to="/meeting/newMeeting">
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 25 }}
          >
            Add Meeting
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={meetingListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Meeting?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MeetingTable;
